// extracted by mini-css-extract-plugin
module.exports = {"root":"UploaderFile_root__ZFMga","bodyContainer":"UploaderFile_bodyContainer__3Pn9N","statusContainer":"UploaderFile_statusContainer__uqqyO"};